'use client';

import { TranslationSnapshotProvider } from '@eliadmin/core/src/i18n/translation-context';
import type { PropsWithChildren } from 'react';
import { GENERATED_TRANSLATIONS } from '../dictionaries/dictionary-7af93f13990d3659ba46c4a8c5adbf0bc394e782898d13ad28bae2024b7ef3aa';

export default function GeneratedLocaleTranslationBoundary({ children }: PropsWithChildren) {
  return (
    <TranslationSnapshotProvider translations={GENERATED_TRANSLATIONS}>
      {children}
    </TranslationSnapshotProvider>
  );
}
